import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-a6521c70"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pos-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "pos-main" };
const _hoisted_4 = { class: "page-header" };
const _hoisted_5 = { class: "header-left" };
const _hoisted_6 = { class: "header-icon" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "page-title" }, "Ventas Retail"),
    /*#__PURE__*/ _createElementVNode("p", { class: "page-subtitle" }, "Punto de Venta (POS) · Registro y despacho de órdenes")
], -1 /* HOISTED */));
const _hoisted_8 = {
    key: 0,
    class: "recover-count"
};
const _hoisted_9 = { class: "pos-layout" };
const _hoisted_10 = { class: "pos-catalog" };
const _hoisted_11 = { class: "search-bar-wrap" };
const _hoisted_12 = { class: "search-wrapper" };
const _hoisted_13 = {
    key: 0,
    class: "product-grid"
};
const _hoisted_14 = { class: "product-card-top" };
const _hoisted_15 = { class: "product-header-row" };
const _hoisted_16 = ["title"];
const _hoisted_17 = { class: "product-sku" };
const _hoisted_18 = { class: "stock-section" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "stock-label" }, "Disponibilidad en almacén", -1 /* HOISTED */));
const _hoisted_20 = { class: "stock-badges" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "stock-dot" }, null, -1 /* HOISTED */));
const _hoisted_22 = { class: "product-card-bottom" };
const _hoisted_23 = {
    key: 0,
    class: "promo-badge"
};
const _hoisted_24 = { class: "promo-tag" };
const _hoisted_25 = { class: "promo-pct" };
const _hoisted_26 = { class: "product-bottom-row" };
const _hoisted_27 = { class: "price-block" };
const _hoisted_28 = {
    key: 0,
    class: "product-price-original"
};
const _hoisted_29 = { class: "product-add-row" };
const _hoisted_30 = ["onUpdate:modelValue"];
const _hoisted_31 = ["onClick", "disabled"];
const _hoisted_32 = { class: "empty-state-catalog" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "No se encontraron productos con la búsqueda actual.", -1 /* HOISTED */));
const _hoisted_34 = { class: "initial-hint" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Busca repuestos por nombre o código para agregarlos al ticket", -1 /* HOISTED */));
const _hoisted_36 = { class: "pos-ticket" };
const _hoisted_37 = { class: "ticket-header" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "ticket-title" }, "Ticket Actual", -1 /* HOISTED */));
const _hoisted_39 = { class: "ticket-subtitle" };
const _hoisted_40 = {
    key: 0,
    class: "ticket-badge"
};
const _hoisted_41 = { class: "ticket-field" };
const _hoisted_42 = { class: "field-label" };
const _hoisted_43 = {
    key: 0,
    class: "ac-dropdown"
};
const _hoisted_44 = ["onMousedown"];
const _hoisted_45 = { class: "ticket-field" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "field-label" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "lni lni-home" }),
    /*#__PURE__*/ _createTextVNode(" Sucursal Despacho")
], -1 /* HOISTED */));
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione una sucursal...", -1 /* HOISTED */));
const _hoisted_48 = ["value"];
const _hoisted_49 = { class: "cart-items-wrap" };
const _hoisted_50 = {
    key: 0,
    class: "cart-empty"
};
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Agrega productos al ticket", -1 /* HOISTED */));
const _hoisted_52 = { class: "cart-item-info" };
const _hoisted_53 = { class: "cart-item-name" };
const _hoisted_54 = { class: "cart-item-meta" };
const _hoisted_55 = { class: "cart-item-right" };
const _hoisted_56 = { class: "cart-item-total" };
const _hoisted_57 = ["onClick"];
const _hoisted_58 = { class: "ticket-footer" };
const _hoisted_59 = { class: "total-display" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "total-label" }, "TOTAL (USD)", -1 /* HOISTED */));
const _hoisted_61 = { class: "total-amount" };
const _hoisted_62 = { class: "ticket-actions" };
const _hoisted_63 = ["disabled"];
const _hoisted_64 = ["disabled"];
const _hoisted_65 = ["disabled"];
const _hoisted_66 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_67 = { class: "modal-window" };
const _hoisted_68 = { class: "modal-header-premium" };
const _hoisted_69 = { class: "modal-title-group" };
const _hoisted_70 = { class: "modal-icon" };
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title-text" }, "Cliente Express"),
    /*#__PURE__*/ _createElementVNode("span", { class: "modal-subtitle" }, "Registro rápido en el sistema")
], -1 /* HOISTED */));
const _hoisted_72 = { class: "form-grid" };
const _hoisted_73 = { class: "form-group-premium" };
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo Doc.", -1 /* HOISTED */));
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: ""
}, "Seleccione tipo...", -1 /* HOISTED */));
const _hoisted_76 = ["value"];
const _hoisted_77 = { class: "form-group-premium" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número de Documento", -1 /* HOISTED */));
const _hoisted_79 = ["placeholder"];
const _hoisted_80 = { class: "form-group-premium" };
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre / Razón Social", -1 /* HOISTED */));
const _hoisted_82 = { class: "form-group-premium" };
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Celular de Contacto", -1 /* HOISTED */));
const _hoisted_84 = { style: { "display": "flex", "gap": "8px" } };
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "+58", -1 /* HOISTED */));
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "+1", -1 /* HOISTED */));
const _hoisted_87 = [
    _hoisted_85,
    _hoisted_86
];
const _hoisted_88 = { class: "form-group-premium" };
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Estado", -1 /* HOISTED */));
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: ""
}, "Seleccione estado...", -1 /* HOISTED */));
const _hoisted_91 = ["value"];
const _hoisted_92 = { class: "form-group-premium" };
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Municipio", -1 /* HOISTED */));
const _hoisted_94 = ["disabled"];
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: ""
}, "Seleccione municipio...", -1 /* HOISTED */));
const _hoisted_96 = ["value"];
const _hoisted_97 = { class: "form-group-premium" };
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Parroquia", -1 /* HOISTED */));
const _hoisted_99 = ["disabled"];
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "0",
    disabled: ""
}, "Seleccione parroquia...", -1 /* HOISTED */));
const _hoisted_101 = ["value"];
const _hoisted_102 = { class: "form-group-premium full-col" };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Dirección Detallada", -1 /* HOISTED */));
const _hoisted_104 = { class: "modal-form-footer" };
const _hoisted_105 = ["disabled"];
const _hoisted_106 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_107 = { class: "modal-window" };
const _hoisted_108 = { class: "modal-header-premium" };
const _hoisted_109 = { class: "modal-title-group" };
const _hoisted_110 = {
    class: "modal-icon",
    style: { "background": "linear-gradient(135deg, #8b5cf6, #6d28d9)" }
};
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title-text" }, "Editar Cliente"),
    /*#__PURE__*/ _createElementVNode("span", { class: "modal-subtitle" }, "Actualizar datos del cliente seleccionado")
], -1 /* HOISTED */));
const _hoisted_112 = { class: "form-grid" };
const _hoisted_113 = { class: "form-group-premium" };
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Documento (No editable)", -1 /* HOISTED */));
const _hoisted_115 = { class: "form-group-premium" };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre / Razón Social", -1 /* HOISTED */));
const _hoisted_117 = { class: "form-group-premium" };
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Celular", -1 /* HOISTED */));
const _hoisted_119 = { class: "form-group-premium" };
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Correo", -1 /* HOISTED */));
const _hoisted_121 = { class: "form-group-premium" };
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Estado", -1 /* HOISTED */));
const _hoisted_123 = ["value"];
const _hoisted_124 = { class: "form-group-premium" };
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Municipio", -1 /* HOISTED */));
const _hoisted_126 = ["value"];
const _hoisted_127 = { class: "form-group-premium" };
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Parroquia", -1 /* HOISTED */));
const _hoisted_129 = ["value"];
const _hoisted_130 = { class: "form-group-premium full-col" };
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Dirección Detallada", -1 /* HOISTED */));
const _hoisted_132 = { class: "modal-form-footer" };
const _hoisted_133 = ["disabled"];
const _hoisted_134 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_135 = {
    class: "modal-window",
    style: { "max-width": "680px" }
};
const _hoisted_136 = { class: "modal-header-premium" };
const _hoisted_137 = { class: "modal-title-group" };
const _hoisted_138 = {
    class: "modal-icon",
    style: { "background": "linear-gradient(135deg, #f59e0b, #d97706)" }
};
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title-text" }, "Órdenes en Borrador", -1 /* HOISTED */));
const _hoisted_140 = { class: "modal-subtitle" };
const _hoisted_141 = { class: "modal-body-form" };
const _hoisted_142 = { class: "table-scroll-modal" };
const _hoisted_143 = { class: "modal-table" };
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Código"),
        /*#__PURE__*/ _createElementVNode("th", null, "Cliente"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Monto"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Acción")
    ])
], -1 /* HOISTED */));
const _hoisted_145 = { key: 0 };
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "4",
    class: "text-center text-muted py-6"
}, "No hay órdenes en pausa.", -1 /* HOISTED */));
const _hoisted_147 = [
    _hoisted_146
];
const _hoisted_148 = { class: "code-chip" };
const _hoisted_149 = { class: "font-medium" };
const _hoisted_150 = { class: "text-end font-bold text-success" };
const _hoisted_151 = { class: "text-center" };
const _hoisted_152 = ["onClick"];
const _hoisted_153 = { class: "modal-form-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_ShoppingCartIcon = _resolveComponent("ShoppingCartIcon");
    const _component_ListIcon = _resolveComponent("ListIcon");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_UserIcon = _resolveComponent("UserIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" ── Page Header ── "),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_ShoppingCartIcon, { size: 22 })
                        ]),
                        _hoisted_7
                    ]),
                    _createElementVNode("button", {
                        class: "btn-recover",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showBorradores = true))
                    }, [
                        _createVNode(_component_ListIcon, { size: 15 }),
                        _createTextVNode(" Recuperar Pendiente "),
                        (_ctx.borradores.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.borradores.length), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createCommentVNode(" ── POS Layout ── "),
                _createElementVNode("div", _hoisted_9, [
                    _createCommentVNode(" ── LEFT: Catálogo ── "),
                    _createElementVNode("div", _hoisted_10, [
                        _createCommentVNode(" Search Bar "),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_SearchIcon, {
                                    size: 17,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    placeholder: "Buscar repuestos por código o nombre...",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                                    onKeyup: _cache[2] || (_cache[2] = _withKeys(
                                    //@ts-ignore
                                    (...args) => (_ctx.buscarProductos && _ctx.buscarProductos(...args)), ["enter"])),
                                    class: "search-input"
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelText, _ctx.searchQuery]
                                ])
                            ]),
                            _createElementVNode("button", {
                                class: "btn-search",
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.buscarProductos && _ctx.buscarProductos(...args)))
                            }, [
                                _createVNode(_component_SearchIcon, { size: 16 }),
                                _createTextVNode(" Buscar ")
                            ])
                        ]),
                        _createCommentVNode(" Product Grid "),
                        (_ctx.productos.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productos, (prod) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "product-card",
                                        key: prod.id
                                    }, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("h5", {
                                                    class: "product-name",
                                                    title: prod.nombre
                                                }, _toDisplayString(prod.nombre), 9 /* TEXT, PROPS */, _hoisted_16),
                                                _createElementVNode("span", _hoisted_17, _toDisplayString(prod.codigo), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_18, [
                                                _hoisted_19,
                                                _createElementVNode("div", _hoisted_20, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prod.stockDetalle, (s) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: s.almacenId,
                                                            class: _normalizeClass(["stock-chip", s.cantidad > 0 ? 'chip-ok' : 'chip-empty'])
                                                        }, [
                                                            _hoisted_21,
                                                            _createTextVNode(" " + _toDisplayString(s.nombre) + ": ", 1 /* TEXT */),
                                                            _createElementVNode("b", null, _toDisplayString(s.cantidad), 1 /* TEXT */)
                                                        ], 2 /* CLASS */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createCommentVNode(" Badge Ahorro "),
                                            (prod.tienePromocion)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createElementVNode("span", _hoisted_24, "🏷️ Ahorro $" + _toDisplayString(prod.ahorroUsd.toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_25, _toDisplayString(prod.porcentajeDescuento) + "% OFF", 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, [
                                                    (prod.tienePromocion)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "$" + _toDisplayString(prod.precioOriginalUsd.toFixed(2)), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["product-price", { 'price-promo': prod.tienePromocion }])
                                                    }, "$" + _toDisplayString(prod.precioUsd.toFixed(2)), 3 /* TEXT, CLASS */)
                                                ]),
                                                _createElementVNode("div", _hoisted_29, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event) => ((prod.cantidadAgregar) = $event),
                                                        min: "1",
                                                        class: "qty-input"
                                                    }, null, 8 /* PROPS */, _hoisted_30), [
                                                        [
                                                            _vModelText,
                                                            prod.cantidadAgregar,
                                                            void 0,
                                                            { number: true }
                                                        ]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        class: "btn-add-cart",
                                                        onClick: ($event) => (_ctx.agregarAlCarrito(prod)),
                                                        disabled: prod.cantidadAgregar < 1
                                                    }, [
                                                        _createVNode(_component_PlusIcon, { size: 15 }),
                                                        _createTextVNode(" Añadir ")
                                                    ], 8 /* PROPS */, _hoisted_31)
                                                ])
                                            ])
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : (_ctx.searchOcurred)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" Empty State "),
                                    _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_ShoppingCartIcon, {
                                            size: 44,
                                            class: "empty-icon"
                                        }),
                                        _hoisted_33
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createCommentVNode(" Initial Hint "),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createVNode(_component_SearchIcon, {
                                            size: 40,
                                            class: "empty-icon"
                                        }),
                                        _hoisted_35
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    ]),
                    _createCommentVNode(" ── RIGHT: Ticket / Carrito ── "),
                    _createElementVNode("div", _hoisted_36, [
                        _createCommentVNode(" Ticket Header "),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", null, [
                                _hoisted_38,
                                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.carrito.length === 0 ? 'Sin ítems' : _ctx.carrito.length + ' ítem(s)'), 1 /* TEXT */)
                            ]),
                            (_ctx.carrito.length > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.carrito.length), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" Cliente "),
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, [
                                _createVNode(_component_UserIcon, { size: 13 }),
                                _createTextVNode(" Cliente "),
                                _createElementVNode("a", {
                                    href: "#",
                                    class: "field-link",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.showClientModal = true), ["prevent"]))
                                }, "+ Nuevo Express")
                            ]),
                            _createElementVNode("div", {
                                class: _normalizeClass(["autocomplete-wrap", { 'is-selected': _ctx.clienteSeleccionado }])
                            }, [
                                _createVNode(_component_UserIcon, {
                                    size: 14,
                                    class: "ac-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.searchClienteQuery) = $event)),
                                    onInput: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onSearchClientesInput && _ctx.onSearchClientesInput(...args))),
                                    class: _normalizeClass(["ac-input", { 'selected': _ctx.clienteSeleccionado }]),
                                    placeholder: "Escriba para buscar cliente...",
                                    onFocus: _cache[7] || (_cache[7] = ($event) => (_ctx.showClientesDropdown = true)),
                                    onBlur: _cache[8] || (_cache[8] =
                                        //@ts-ignore
                                        (...args) => (_ctx.hideClientesDropdown && _ctx.hideClientesDropdown(...args)))
                                }, null, 34 /* CLASS, NEED_HYDRATION */), [
                                    [_vModelText, _ctx.searchClienteQuery]
                                ]),
                                (_ctx.clienteSeleccionado)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "ac-edit-btn",
                                        onClick: _cache[9] || (_cache[9] =
                                            //@ts-ignore
                                            (...args) => (_ctx.abrirEditarCliente && _ctx.abrirEditarCliente(...args))),
                                        title: "Editar cliente"
                                    }, [
                                        _createVNode(_component_EditIcon, { size: 13 })
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */),
                            (_ctx.showClientesDropdown && _ctx.clientes.length > 0)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientes, (cli) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: cli.id,
                                            class: "ac-option",
                                            onMousedown: _withModifiers(($event) => (_ctx.seleccionarCliente(cli.id, cli.nombre)), ["prevent"])
                                        }, [
                                            _createVNode(_component_UserIcon, { size: 13 }),
                                            _createTextVNode(" " + _toDisplayString(cli.nombre), 1 /* TEXT */)
                                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_44));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createCommentVNode(" Sucursal "),
                        _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _withDirectives(_createElementVNode("select", {
                                class: "field-select",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.sucursalSeleccionada) = $event))
                            }, [
                                _hoisted_47,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sucursales, (suc) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: suc.id,
                                        value: suc.id
                                    }, _toDisplayString(suc.nombre), 9 /* TEXT, PROPS */, _hoisted_48));
                                }), 128 /* KEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.sucursalSeleccionada]
                            ])
                        ]),
                        _createCommentVNode(" Cart Items "),
                        _createElementVNode("div", _hoisted_49, [
                            (_ctx.carrito.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createVNode(_component_ShoppingCartIcon, {
                                        size: 36,
                                        class: "cart-empty-icon"
                                    }),
                                    _hoisted_51
                                ]))
                                : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carrito, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "cart-item"
                                }, [
                                    _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("span", _hoisted_53, _toDisplayString(item.nombre), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_54, "$" + _toDisplayString(item.precioUnitarioUsd.toFixed(2)) + " × " + _toDisplayString(item.cantidad), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("span", _hoisted_56, "$" + _toDisplayString((item.precioUnitarioUsd * item.cantidad).toFixed(2)), 1 /* TEXT */),
                                        _createElementVNode("button", {
                                            class: "btn-remove-item",
                                            onClick: ($event) => (_ctx.quitarDelCarrito(index))
                                        }, [
                                            _createVNode(_component_TrashIcon, { size: 14 })
                                        ], 8 /* PROPS */, _hoisted_57)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _createCommentVNode(" Total + Actions "),
                        _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                                _hoisted_60,
                                _createElementVNode("span", _hoisted_61, "$" + _toDisplayString(_ctx.totalCarrito.toFixed(2)), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                    class: "btn-ticket-secondary",
                                    onClick: _cache[11] || (_cache[11] =
                                        //@ts-ignore
                                        (...args) => (_ctx.guardarBorrador && _ctx.guardarBorrador(...args))),
                                    disabled: _ctx.carrito.length === 0 || !_ctx.clienteSeleccionado || !_ctx.sucursalSeleccionada
                                }, [
                                    _createVNode(_component_ListIcon, { size: 15 }),
                                    _createTextVNode(" Pausar ")
                                ], 8 /* PROPS */, _hoisted_63),
                                _createElementVNode("button", {
                                    class: "btn-ticket-primary",
                                    onClick: _cache[12] || (_cache[12] =
                                        //@ts-ignore
                                        (...args) => (_ctx.procesarVenta && _ctx.procesarVenta(...args))),
                                    disabled: _ctx.carrito.length === 0 || !_ctx.clienteSeleccionado || !_ctx.sucursalSeleccionada
                                }, [
                                    _createVNode(_component_CheckCircleIcon, { size: 16 }),
                                    _createTextVNode(" Cobrar a Caja ")
                                ], 8 /* PROPS */, _hoisted_64)
                            ]),
                            _createElementVNode("button", {
                                class: "btn-clear-cart",
                                onClick: _cache[13] || (_cache[13] =
                                    //@ts-ignore
                                    (...args) => (_ctx.cancelarVenta && _ctx.cancelarVenta(...args))),
                                disabled: _ctx.carrito.length === 0
                            }, [
                                _createVNode(_component_TrashIcon, { size: 13 }),
                                _createTextVNode(" Limpiar Ticket ")
                            ], 8 /* PROPS */, _hoisted_65)
                        ])
                    ])
                ])
            ])
        ]),
        _createCommentVNode(" ── Modal Nuevo Cliente Express ── "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                (_ctx.showClientModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                        _createVNode(_component_UserIcon, { size: 20 })
                                    ]),
                                    _hoisted_71
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.showClientModal = false)),
                                    class: "btn-modal-close"
                                }, [
                                    _createVNode(_component_XIcon, { size: 22 })
                                ])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _cache[29] || (_cache[29] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.crearClienteExpress && _ctx.crearClienteExpress(...args)), ["prevent"])),
                                class: "modal-body-form"
                            }, [
                                _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                        _hoisted_74,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.nuevoCliente.tipoDocumentoId) = $event)),
                                            onChange: _cache[16] || (_cache[16] =
                                                //@ts-ignore
                                                (...args) => (_ctx.updateDocumentoPrefixExpress && _ctx.updateDocumentoPrefixExpress(...args))),
                                            required: ""
                                        }, [
                                            _hoisted_75,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestros.tiposDocumento, (td) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: td.tipoDocumentoId,
                                                    value: td.tipoDocumentoId
                                                }, _toDisplayString(td.descripcion), 9 /* TEXT, PROPS */, _hoisted_76));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelSelect, _ctx.nuevoCliente.tipoDocumentoId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_77, [
                                        _hoisted_78,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.nuevoCliente.documento) = $event)),
                                            onInput: _cache[18] || (_cache[18] =
                                                //@ts-ignore
                                                (...args) => (_ctx.cleanDocumentoExpress && _ctx.cleanDocumentoExpress(...args))),
                                            placeholder: _ctx.placeholderDocExpress,
                                            required: ""
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_79), [
                                            [_vModelText, _ctx.nuevoCliente.documento]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                        _hoisted_81,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.nuevoCliente.nombre) = $event)),
                                            required: "",
                                            placeholder: "Nombre completo"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.nuevoCliente.nombre]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                        _hoisted_83,
                                        _createElementVNode("div", _hoisted_84, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.nuevoCliente.telCelularPrefix) = $event)),
                                                style: { "width": "90px" },
                                                required: ""
                                            }, _hoisted_87, 512 /* NEED_PATCH */), [
                                                [_vModelSelect, _ctx.nuevoCliente.telCelularPrefix]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.nuevoCliente.telCelularNumber) = $event)),
                                                required: "",
                                                placeholder: "412 1234567",
                                                style: { "flex": "1" }
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, _ctx.nuevoCliente.telCelularNumber]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_88, [
                                        _hoisted_89,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.nuevoCliente.estadoId) = $event)),
                                            onChange: _cache[23] || (_cache[23] =
                                                //@ts-ignore
                                                (...args) => (_ctx.onEstadoChange && _ctx.onEstadoChange(...args))),
                                            required: ""
                                        }, [
                                            _hoisted_90,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestros.estados, (e) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: e.estadoId,
                                                    value: e.estadoId
                                                }, _toDisplayString(e.nombre), 9 /* TEXT, PROPS */, _hoisted_91));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelSelect, _ctx.nuevoCliente.estadoId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_92, [
                                        _hoisted_93,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.nuevoCliente.municipioId) = $event)),
                                            onChange: _cache[25] || (_cache[25] =
                                                //@ts-ignore
                                                (...args) => (_ctx.onMunicipioChange && _ctx.onMunicipioChange(...args))),
                                            disabled: !_ctx.nuevoCliente.estadoId,
                                            required: ""
                                        }, [
                                            _hoisted_95,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestros.municipios, (m) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: m.municipioId,
                                                    value: m.municipioId
                                                }, _toDisplayString(m.nombre), 9 /* TEXT, PROPS */, _hoisted_96));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_94), [
                                            [_vModelSelect, _ctx.nuevoCliente.municipioId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_97, [
                                        _hoisted_98,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.nuevoCliente.parroquiaId) = $event)),
                                            disabled: !_ctx.nuevoCliente.municipioId,
                                            required: ""
                                        }, [
                                            _hoisted_100,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestros.parroquias, (p) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: p.parroquiaId,
                                                    value: p.parroquiaId
                                                }, _toDisplayString(p.nombre), 9 /* TEXT, PROPS */, _hoisted_101));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 8 /* PROPS */, _hoisted_99), [
                                            [_vModelSelect, _ctx.nuevoCliente.parroquiaId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_102, [
                                        _hoisted_103,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.nuevoCliente.direccion) = $event)),
                                            required: "",
                                            placeholder: "Av. Principal local 4..."
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.nuevoCliente.direccion]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_104, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-modal-cancel",
                                        onClick: _cache[28] || (_cache[28] = ($event) => (_ctx.showClientModal = false))
                                    }, "Cancelar"),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn-modal-submit",
                                        disabled: _ctx.guardandoCliente || _ctx.nuevoCliente.parroquiaId === 0
                                    }, [
                                        (!_ctx.guardandoCliente)
                                            ? (_openBlock(), _createBlock(_component_PlusIcon, {
                                                key: 0,
                                                size: 16
                                            }))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.guardandoCliente ? 'Inscribiendo...' : 'Inscribir y Cargar a Caja'), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_105)
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }),
        _createCommentVNode(" ── Modal Editar Cliente ── "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                (_ctx.showEditClientModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                            _createElementVNode("div", _hoisted_108, [
                                _createElementVNode("div", _hoisted_109, [
                                    _createElementVNode("div", _hoisted_110, [
                                        _createVNode(_component_EditIcon, { size: 20 })
                                    ]),
                                    _hoisted_111
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[30] || (_cache[30] = ($event) => (_ctx.showEditClientModal = false)),
                                    class: "btn-modal-close"
                                }, [
                                    _createVNode(_component_XIcon, { size: 22 })
                                ])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _cache[42] || (_cache[42] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.guardarEdicionCliente && _ctx.guardarEdicionCliente(...args)), ["prevent"])),
                                class: "modal-body-form"
                            }, [
                                _createElementVNode("div", _hoisted_112, [
                                    _createElementVNode("div", _hoisted_113, [
                                        _hoisted_114,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_ctx.clienteEditando.documento) = $event)),
                                            disabled: "",
                                            class: "disabled-input"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.clienteEditando.documento]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_115, [
                                        _hoisted_116,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_ctx.clienteEditando.nombre) = $event)),
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.clienteEditando.nombre]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_117, [
                                        _hoisted_118,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((_ctx.clienteEditando.celular) = $event)),
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.clienteEditando.celular]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_119, [
                                        _hoisted_120,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((_ctx.clienteEditando.email) = $event)),
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.clienteEditando.email]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_121, [
                                        _hoisted_122,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((_ctx.clienteEditando.estadoId) = $event)),
                                            onChange: _cache[36] || (_cache[36] =
                                                //@ts-ignore
                                                (...args) => (_ctx.onEstadoEditChange && _ctx.onEstadoEditChange(...args))),
                                            required: ""
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestros.estados, (e) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: e.estadoId,
                                                    value: e.estadoId
                                                }, _toDisplayString(e.nombre), 9 /* TEXT, PROPS */, _hoisted_123));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelSelect, _ctx.clienteEditando.estadoId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_124, [
                                        _hoisted_125,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((_ctx.clienteEditando.municipioId) = $event)),
                                            onChange: _cache[38] || (_cache[38] =
                                                //@ts-ignore
                                                (...args) => (_ctx.onMunicipioEditChange && _ctx.onMunicipioEditChange(...args))),
                                            required: ""
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestrosEdit.municipios, (m) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: m.municipioId,
                                                    value: m.municipioId
                                                }, _toDisplayString(m.nombre), 9 /* TEXT, PROPS */, _hoisted_126));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelSelect, _ctx.clienteEditando.municipioId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_127, [
                                        _hoisted_128,
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((_ctx.clienteEditando.parroquiaId) = $event)),
                                            required: ""
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maestrosEdit.parroquias, (p) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: p.parroquiaId,
                                                    value: p.parroquiaId
                                                }, _toDisplayString(p.nombre), 9 /* TEXT, PROPS */, _hoisted_129));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */), [
                                            [_vModelSelect, _ctx.clienteEditando.parroquiaId]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_130, [
                                        _hoisted_131,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((_ctx.clienteEditando.direccion) = $event)),
                                            required: ""
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, _ctx.clienteEditando.direccion]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-modal-cancel",
                                        onClick: _cache[41] || (_cache[41] = ($event) => (_ctx.showEditClientModal = false))
                                    }, "Cancelar"),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn-modal-submit",
                                        disabled: _ctx.guardandoCliente
                                    }, [
                                        (!_ctx.guardandoCliente)
                                            ? (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                                                key: 0,
                                                size: 16
                                            }))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.guardandoCliente ? 'Guardando...' : 'Guardar Cambios'), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_133)
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }),
        _createCommentVNode(" ── Modal Recuperar Pendientes ── "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                (_ctx.showBorradores)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                        _createElementVNode("div", _hoisted_135, [
                            _createElementVNode("div", _hoisted_136, [
                                _createElementVNode("div", _hoisted_137, [
                                    _createElementVNode("div", _hoisted_138, [
                                        _createVNode(_component_ListIcon, { size: 20 })
                                    ]),
                                    _createElementVNode("div", null, [
                                        _hoisted_139,
                                        _createElementVNode("span", _hoisted_140, "Tickets pausados · " + _toDisplayString(_ctx.borradores.length) + " pendiente(s)", 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[43] || (_cache[43] = ($event) => (_ctx.showBorradores = false)),
                                    class: "btn-modal-close"
                                }, [
                                    _createVNode(_component_XIcon, { size: 22 })
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("div", _hoisted_142, [
                                    _createElementVNode("table", _hoisted_143, [
                                        _hoisted_144,
                                        _createElementVNode("tbody", null, [
                                            (_ctx.borradores.length === 0)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_145, _hoisted_147))
                                                : _createCommentVNode("v-if", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.borradores, (b) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: b.ordenVentaId
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_148, _toDisplayString(b.codigoOrden), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_149, _toDisplayString(b.nombreCliente), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_150, "$" + _toDisplayString(b.totalDolares.toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_151, [
                                                        _createElementVNode("button", {
                                                            class: "btn-load-draft",
                                                            onClick: ($event) => (_ctx.cargarBorrador(b))
                                                        }, [
                                                            _createVNode(_component_ShoppingCartIcon, { size: 13 }),
                                                            _createTextVNode(" Cargar a Caja ")
                                                        ], 8 /* PROPS */, _hoisted_152)
                                                    ])
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_153, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-modal-cancel",
                                        onClick: _cache[44] || (_cache[44] = ($event) => (_ctx.showBorradores = false))
                                    }, "Cerrar")
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
